import { render, staticRenderFns } from "./RankTab.vue?vue&type=template&id=49f0f979"
import script from "./RankTab.vue?vue&type=script&lang=js"
export * from "./RankTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports